import { render, staticRenderFns } from "./EmploymentForm.vue?vue&type=template&id=6023c4b8&"
import script from "./EmploymentForm.vue?vue&type=script&lang=js&"
export * from "./EmploymentForm.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports